module.exports = __webpack_public_path__ + "img/icon4.73630a1b.png";